import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import SignUp from './SignUp';
import Create from './Create.js';
import Forgot from './Forgot.js';
import { Provider } from "react-redux";
import { GoogleOAuthProvider } from '@react-oauth/google';
import Home from "./Routes/Home";
import Sent from "./Routes/Sent.js";
import Trash from "./Routes/Trash.js";
import Spam from "./Routes/Spam.js";
import Category from "./Routes/Category.js";
import Draft from "./Routes/Draft.js";
import Important from "./Routes/Important.js";
import Settings from "./Routes/Settings.js";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import { requireAuth, signupAuth } from "./authMiddleware.js";
import 'react-toastify/dist/ReactToastify.css';
import './assets/css/quill.css';
import store from './store.js';
import { LoadingProvider } from './context/LoadingContext';
import { AppLayout, InitialLayout } from './Layouts.js';
import { config } from './helper/configVariable.js'



const pathArray = [
  { path: "/home", element: <Home /> },
  { path: "/settings", element: <Settings /> },
  { path: "/sent", element: <Sent /> },
  { path: "/trash", element: <Trash /> },
  { path: "/important", element: <Important /> },
  { path: "/spam", element: <Spam /> },
  { path: "/draft", element: <Draft /> },
  { path: "/category", element: <Category /> }
];

const router = createBrowserRouter([
  {
    element: <AppLayout />,
    loader: requireAuth,
    children: pathArray,
  },
  {
    element: <InitialLayout />,
    children: [
      { path: "/", element: <App /> },
      { path: "/signup", loader: signupAuth, element: <SignUp /> },
      { path: "/create", element: <Create /> },
      { path: "/forgot", element: <Forgot /> }
    ],
  }
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <GoogleOAuthProvider clientId={config.GOOGLE_CLIENT_ID}>
    <Provider store={store}>
      <LoadingProvider>
        <RouterProvider router={router} />
      </LoadingProvider>
    </Provider>
  </GoogleOAuthProvider>
);
